import { NavLink } from 'react-router-dom'

const links = [
  {
    to: '/cuenta',
    label: 'Inicio',
    end: true,
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 11l9-7 9 7" />
        <path d="M5 10v10h14V10" />
      </svg>
    ),
  },
  {
    to: '/cuenta/certificados',
    label: 'Certificados',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="6" />
        <path d="M9 13.5 6 22l6-3.2 6 3.2-3-8.5" />
      </svg>
    ),
  },
  {
    to: '/cuenta/perfil',
    label: 'Perfil',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7" />
      </svg>
    ),
  },
]

export function AccountNav() {
  return (
    <nav className="account-nav">
      {links.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) => `account-nav__link${isActive ? ' account-nav__link--active' : ''}`}
        >
          <span className="account-nav__icon">{link.icon}</span>
          <span className="account-nav__label">{link.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
